import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useDeleteProjectContributors = (projectId, contributorId) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      await fetchContext.authAxios.delete(
        `/projects/${projectId}/contributors/${contributorId}`
      );
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(["project", projectId, "contributors"]);
      },
    }
  );
};
